import {RoleFormDefaultValues, RoleFormProps, RoleFormRawValues, RoleFormType} from "./RoleForm";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";

const getInitialValues = (defaultValues: RoleFormDefaultValues | undefined): RoleFormRawValues => {
  return {
    name: defaultValues?.name,
    description: defaultValues?.description,
  }
}

export type UseRoleFormProps = Pick<RoleFormProps, 'defaultValues'> & {}

export function useRoleForm(props: UseRoleFormProps): RoleFormType {
  const {
    defaultValues
  } = props

  const {t} = useTranslation(["common"])

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
    }),
    validate: {
      name: (value) => value ? undefined : t("common.validation.required", "Required"),
    },
  })

  return form
}
